"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdjudicationSubmissionReceiptSchema = exports.AdjudicationItemResultSchema = exports.AdjudicationRequestSchema = exports.AdjudicationItemAnswerSchema = exports.KnownErrorCitationSchema = exports.AdjudicationAnsweredReasonSchema = exports.AdjudicationAnsweredReason = exports.AdjudicationItemDispositionSchema = exports.AdjudicationItemDisposition = exports.AdjudicationItemInputSchema = exports.ADJUDICATION_CONCERN_MAX_LENGTH = exports.AdjudicationSourceKindSchema = exports.AdjudicationSourceKind = void 0;
const z = require("zod");
const consensus_types_1 = require("../Consensus/consensus.types");
const property_key_1 = require("../Consensus/property-key");
const slice_key_1 = require("../Consensus/slice-key");
const package_data_adjudication_types_1 = require("./package-data-adjudication.types");
const service_contracts_1 = require("./service-contracts");
var AdjudicationSourceKind;
(function (AdjudicationSourceKind) {
    AdjudicationSourceKind["Experiment"] = "experiment";
    AdjudicationSourceKind["AgentAudit"] = "agent_audit";
    AdjudicationSourceKind["Manual"] = "manual";
})(AdjudicationSourceKind || (exports.AdjudicationSourceKind = AdjudicationSourceKind = {}));
exports.AdjudicationSourceKindSchema = z.nativeEnum(AdjudicationSourceKind);
exports.ADJUDICATION_CONCERN_MAX_LENGTH = 1000;
const AdjudicationItemInputShape = z.object({
    address: package_data_adjudication_types_1.DataAnchorAddressSchema,
    proposedValue: package_data_adjudication_types_1.AnchoredDatumSchema.nullable(),
    concern: z.string().trim().min(1).max(exports.ADJUDICATION_CONCERN_MAX_LENGTH).nullable().optional(),
});
exports.AdjudicationItemInputSchema = AdjudicationItemInputShape.superRefine((item, ctx) => {
    if (item.proposedValue === null || item.proposedValue.kind === item.address.anchor.kind) {
        return;
    }
    ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: item.address.anchor.kind === consensus_types_1.AnchorKind.Field ?
            'A field anchor puts a value in doubt and cannot carry a row datum.'
            : 'A row anchor puts the row itself in doubt and cannot carry a field datum.',
        path: ['proposedValue'],
    });
});
var AdjudicationItemDisposition;
(function (AdjudicationItemDisposition) {
    AdjudicationItemDisposition["Answered"] = "answered";
    AdjudicationItemDisposition["PendingExisting"] = "pending_existing";
    AdjudicationItemDisposition["PendingNew"] = "pending_new";
})(AdjudicationItemDisposition || (exports.AdjudicationItemDisposition = AdjudicationItemDisposition = {}));
exports.AdjudicationItemDispositionSchema = z.nativeEnum(AdjudicationItemDisposition);
var AdjudicationAnsweredReason;
(function (AdjudicationAnsweredReason) {
    AdjudicationAnsweredReason["GroundTruthVetted"] = "ground_truth_vetted";
    AdjudicationAnsweredReason["ProposedValueCorrect"] = "proposed_value_correct";
    AdjudicationAnsweredReason["ProposedValueKnownError"] = "proposed_value_known_error";
    AdjudicationAnsweredReason["AddressRuledAbsent"] = "address_ruled_absent";
})(AdjudicationAnsweredReason || (exports.AdjudicationAnsweredReason = AdjudicationAnsweredReason = {}));
exports.AdjudicationAnsweredReasonSchema = z.nativeEnum(AdjudicationAnsweredReason);
exports.KnownErrorCitationSchema = z.object({
    statementId: z.string(),
    violatedClauses: package_data_adjudication_types_1.ClauseCitationSchema.array(),
    errorCodeIds: z.string().array(),
    comment: z.string().nullable(),
    adjudicatedByUserId: z.string(),
    adjudicatedByUserName: z.string().nullable(),
    adjudicatedAt: z.date(),
    planId: z.string().nullable(),
});
exports.AdjudicationItemAnswerSchema = z.object({
    reason: exports.AdjudicationAnsweredReasonSchema,
    groundTruthStatus: package_data_adjudication_types_1.GroundTruthStandingStatusSchema,
    groundTruth: package_data_adjudication_types_1.AnchoredDatumSchema.nullable(),
    groundTruthClauses: package_data_adjudication_types_1.ClauseCitationSchema.array(),
    groundTruthProvenance: service_contracts_1.StatementProvenanceSchema.nullable(),
    errorCitation: exports.KnownErrorCitationSchema.nullable(),
});
exports.AdjudicationRequestSchema = z.object({
    id: z.string(),
    planId: z.string().nullable(),
    packageId: z.string(),
    propertyKey: property_key_1.PropertyKeySchema,
    sliceKey: slice_key_1.SliceKeySchema,
    sliceVersion: z.number().int(),
    createdAt: z.date(),
});
exports.AdjudicationItemResultSchema = z.object({
    address: package_data_adjudication_types_1.DataAnchorAddressSchema,
    disposition: exports.AdjudicationItemDispositionSchema,
    answer: exports.AdjudicationItemAnswerSchema.nullable(),
    requestId: z.string().nullable(),
    planId: z.string().nullable(),
});
exports.AdjudicationSubmissionReceiptSchema = z.object({
    items: exports.AdjudicationItemResultSchema.array(),
    newRequests: exports.AdjudicationRequestSchema.array(),
    existingRequests: exports.AdjudicationRequestSchema.array(),
});
//# sourceMappingURL=adjudication-request.types.js.map